export default __webpack_public_path__ + "static/about-rich-men-smiling-c1c300fce569b43a8cc09076b57aa22c.png";